/* CE v12: add once, confirm on the product page, then let the customer choose the cart. */
(function () {
 'use strict';
 if (window.CEProductInstalled) return;
 window.CEProductInstalled = true;

 // Kept in this asset so existing, personalized themes need only this one file replaced.
 var notice, noticeOwner, noticeTrigger, cartRefresh = 0;

 function dismissNotice() {
  if (!notice) return;
  var restore = notice.contains(document.activeElement);
  notice.hidden = true;
  if (restore && noticeTrigger && noticeTrigger.isConnected) {
   noticeTrigger.focus({preventScroll:true});
  }
 }

 function prepareNotice() {
  if (notice) return notice;

  var style = document.createElement('style');
  style.textContent = [
   '.ce-site.ce-p-added{position:fixed;z-index:10000;top:24px;right:24px;width:390px;max-width:calc(100vw - 32px);max-height:calc(100dvh - 32px);overflow:auto;padding:22px;border:1px solid var(--ce-accent);border-radius:10px;background:var(--ce-card);color:#202020;box-shadow:0 12px 40px #0002;font:14px/1.5 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}',
   '.ce-site.ce-p-added[hidden]{display:none!important}',
   '.ce-p-added [role=status]{padding-right:30px;overflow-wrap:anywhere}',
   '.ce-p-added strong{display:block;font-size:19px;line-height:1.3;margin:0 0 8px;color:#202020}',
   '.ce-site.ce-p-added p{font-size:14px;line-height:1.5;margin:0;color:#514941}',
   '.ce-p-added-close{position:absolute;top:6px;right:6px;min-width:44px;min-height:44px;border:0;background:transparent;color:#202020;cursor:pointer;font-size:25px!important}',
   '.ce-p-added-actions{display:flex;gap:10px;margin-top:18px;flex-wrap:wrap}',
   '.ce-p-added-actions>a,.ce-p-added-actions>button{flex:1;display:flex;align-items:center;justify-content:center;min-width:110px;min-height:44px;padding:10px;border:1px solid var(--ce-accent);border-radius:5px;font:600 13px/1.4 system-ui,sans-serif;text-align:center;cursor:pointer}',
   '.ce-p-added-actions>a{background:var(--ce-button);color:var(--ce-button-ink)!important;border-color:var(--ce-button)}',
   '.ce-p-added-actions>button{background:transparent;color:#202020}',
   '.ce-p-added button:focus-visible,.ce-p-added a:focus-visible{outline:3px solid var(--ce-accent);outline-offset:2px}',
   '@media(max-width:760px){.ce-site.ce-p-added{top:max(12px,env(safe-area-inset-top));right:12px;max-width:calc(100vw - 24px);padding:18px;width:390px}}'
  ].join('\n');

  document.head.appendChild(style);

  notice = document.createElement('aside');
  notice.className = 'ce-site ce-p-added';
  notice.hidden = true;
  notice.setAttribute('aria-label', 'Confirmare adăugare în coș');

  // All variable product content is assigned with textContent below.
  notice.innerHTML = '<button type="button" class="ce-p-added-close" aria-label="Închide confirmarea">×</button><div role="status" aria-live="polite" aria-atomic="true"><strong data-ce-added-title></strong><p data-ce-added-summary></p></div><div class="ce-p-added-actions"><a data-ce-added-cart>Vezi coșul</a><button type="button" data-ce-keep-shopping>Continui cumpărăturile</button></div>';

  document.body.appendChild(notice);

  notice.querySelector('.ce-p-added-close').addEventListener('click', dismissNotice);
  notice.querySelector('[data-ce-keep-shopping]').addEventListener('click', dismissNotice);

  document.addEventListener('keydown', function (event) {
   if (event.key === 'Escape' && !notice.hidden) dismissNotice();
  });

  return notice;
 }

 function showNotice(root, summary, trigger) {
  prepareNotice();
  noticeOwner = root;
  noticeTrigger = trigger;

  notice.querySelector('[data-ce-added-cart]').href = root.dataset.cartUrl;
  notice.querySelector('[data-ce-added-title]').textContent = '';
  notice.querySelector('[data-ce-added-summary]').textContent = '';
  notice.hidden = false;

  requestAnimationFrame(function () {
   notice.querySelector('[data-ce-added-title]').textContent = 'Adăugat în coș';
   notice.querySelector('[data-ce-added-summary]').textContent = summary;
  });
 }

 async function refreshCart(cartUrl) {
  var revision = ++cartRefresh;
  var controller = new AbortController();
  var timeout = setTimeout(function () {
   controller.abort();
  }, 8000);

  try {
   var url = new URL(cartUrl, location.href);
   url.pathname = url.pathname.replace(/\/$/, '') + '.js';
   url.search = '';
   url.hash = '';

   var response = await fetch(url, {
    headers: {Accept:'application/json'},
    credentials: 'same-origin',
    cache: 'no-store',
    signal: controller.signal
   });

   if (!response.ok) throw new Error('cart-read');

   var cart = await response.json();

   if (!Number.isInteger(cart.item_count) || cart.item_count < 0) {
    throw new Error('cart-read');
   }

   if (revision !== cartRefresh) return;

   document.querySelectorAll('.ce-cart-count').forEach(function (badge) {
    badge.textContent = String(cart.item_count);
    badge.hidden = false;

    var link = badge.closest('a');
    if (link) {
     link.setAttribute(
      'aria-label',
      'Coș de cumpărături: ' + cart.item_count + ' ' +
      (cart.item_count === 1 ? 'produs' : 'produse')
     );
    }
   });
  } catch (_) {
   // A failed count refresh never retries the successful add.
   if (revision !== cartRefresh) return;

   document.querySelectorAll('.ce-cart-count').forEach(function (badge) {
    badge.hidden = true;
    var link = badge.closest('a');
    if (link) link.setAttribute('aria-label', 'Coș de cumpărături');
   });
  } finally {
   clearTimeout(timeout);
  }
 }

 function init(scope) {
  scope.querySelectorAll('[data-ce-product]').forEach(function (root) {
   if (root.ceProductCleanup) return;

   var form = root.querySelector('.ce-p-form');
   var select = root.querySelector('[data-ce-variant-select]');
   if (!form || !select) return;

   prepareNotice();

   var quantity = form.elements.quantity;
   var buttons = root.querySelector('[data-ce-variant-buttons]');
   var submits = root.querySelectorAll('[data-ce-submit]');
   var error = root.querySelector('[data-ce-error]');
   var deadline = Date.parse(root.dataset.closeAt);
   var busy = false;
   var previousClosed;
   var controller = new AbortController();
   var options = {signal: controller.signal};

   var state = function () {
    return select.options[select.selectedIndex];
   };

   function closed() {
    return Number.isFinite(deadline) && Date.now() >= deadline;
   }

   function updateButtons() {
    var available = state() && state().dataset.available === 'true';

    var label = closed()
     ? 'Precomenzi închise'
     : root.dataset.requiresPlan === 'true'
     ? 'Indisponibil aici'
     : !available
     ? 'Indisponibil'
     : busy
     ? 'Se adaugă…'
     : 'Adaugă în precomandă';

    submits.forEach(function (button) {
     button.disabled =
      busy ||
      closed() ||
      !available ||
      root.dataset.requiresPlan === 'true';
     button.textContent = label;
    });

    form.setAttribute('aria-busy', String(busy));
   }

   function showMedia(id) {
    if (!id || !Array.from(root.querySelectorAll('[data-media-id]')).some(function (panel) {
     return panel.dataset.mediaId === id;
    })) return;

    root.querySelectorAll('[data-media-id]').forEach(function (panel) {
     panel.hidden = panel.dataset.mediaId !== id;

     if (panel.hidden) {
      panel.querySelectorAll('video').forEach(function (video) {
       video.pause();
      });

      panel.querySelectorAll('iframe').forEach(function (frame) {
       if (frame.src) {
        var src = frame.src;
        frame.src = src;
       }
      });
     }
    });

    root.querySelectorAll('[data-media-button]').forEach(function (button) {
     button.setAttribute(
      'aria-pressed',
      String(button.dataset.mediaButton === id)
     );
    });
   }

   function normalizeQuantity() {
    var min = Number(quantity.min) || 1;
    var step = Number(quantity.step) || 1;
    var max = quantity.max ? Number(quantity.max) : Infinity;
    var value = Number(quantity.value);

    if (!Number.isFinite(value) || value < min) value = min;
    value = min + Math.floor((value - min) / step) * step;

    var limit = Number.isFinite(max)
     ? min + Math.floor((max - min) / step) * step
     : Infinity;

    quantity.value = Math.max(min, Math.min(value, limit));

    root.querySelector('[data-quantity-change="-1"]').disabled =
     Number(quantity.value) <= min;

    root.querySelector('[data-quantity-change="1"]').disabled =
     Number(quantity.value) + step > max;
   }

   function sync(updateUrl, changeMedia) {
    var selected = state();
    if (!selected) return;

    root.querySelectorAll('[data-ce-price]').forEach(function (node) {
     node.textContent = selected.dataset.price;
    });

    var compare = root.querySelector('[data-ce-compare]');
    compare.textContent = selected.dataset.compare;
    compare.hidden = !selected.dataset.compare;

    var unit = root.querySelector('[data-ce-unit]');
    unit.textContent = selected.dataset.unit || '';
    unit.hidden = !selected.dataset.unit;

    var sticky = root.querySelector('[data-ce-sticky-variant]');
    if (sticky && selected.dataset.title !== 'Default Title') {
     sticky.textContent = selected.dataset.title;
    }

    root.querySelectorAll('[data-variant-id]').forEach(function (button) {
     button.setAttribute(
      'aria-pressed',
      String(button.dataset.variantId === select.value)
     );
    });

    quantity.min = selected.dataset.min || '1';
    quantity.step = selected.dataset.step || '1';
    quantity.max = selected.dataset.max || '';

    normalizeQuantity();
    updateButtons();

    if (changeMedia) showMedia(selected.dataset.media);

    if (updateUrl) {
     var url = new URL(location.href);
     url.searchParams.set('variant', select.value);
     history.replaceState(null, '', url);
    }

    error.hidden = true;
   }

   if (buttons) {
    buttons.hidden = false;
    select.hidden = true;
   }

   root.addEventListener('click', function (event) {
    var variant = event.target.closest('[data-variant-id]');
    if (variant && !variant.disabled) {
     select.value = variant.dataset.variantId;
     sync(true, true);
    }

    var media = event.target.closest('[data-media-button]');
    if (media) showMedia(media.dataset.mediaButton);

    var qty = event.target.closest('[data-quantity-change]');
    if (qty) {
     quantity.value =
      Number(quantity.value || quantity.min) +
      Number(qty.dataset.quantityChange) * Number(quantity.step);
     normalizeQuantity();
    }

    var link = event.target.closest('[data-ce-open-details]');
    if (link) {
     var target = document.getElementById(link.hash.slice(1));
     if (target) target.open = true;
    }
   }, options);

   select.addEventListener('change', function () {
    sync(true, true);
   }, options);

   quantity.addEventListener('change', normalizeQuantity, options);

   form.addEventListener('submit', async function (event) {
    event.preventDefault();
    if (busy) return;

    sync(false, false);

    if (
     closed() ||
     !state() ||
     state().dataset.available !== 'true' ||
     root.dataset.requiresPlan === 'true'
    ) return;

    if (!form.reportValidity()) return;

    dismissNotice();

    var addedVariant = state().dataset.title;
    var summary =
     quantity.value + ' × ' +
     root.querySelector('h1').textContent.trim() +
     (addedVariant && addedVariant !== 'Default Title'
      ? ' · ' + addedVariant
      : '');

    var trigger = event.submitter || document.activeElement;

    busy = true;
    updateButtons();

    try {
     var payload = new FormData(form);
     payload.delete('return_to');

     var response = await fetch(root.dataset.addUrl, {
      method: 'POST',
      body: payload,
      headers: {Accept:'application/json'},
      credentials: 'same-origin'
     });

     var data;
     try {
      data = await response.json();
     } catch (_) {
      throw new Error(
       'Nu am putut confirma adăugarea. Verifică produsele din coș înainte să încerci din nou.'
      );
     }

     if (!response.ok || data.status) {
      throw new Error(
       typeof data.description === 'string'
        ? data.description
        : 'Preparatul nu a putut fi adăugat. Verifică disponibilitatea și încearcă din nou.'
      );
     }

     showNotice(root, summary, trigger);
     refreshCart(root.dataset.cartUrl);

    } catch (failure) {
     error.textContent = failure.message === 'Failed to fetch'
      ? 'Nu am putut confirma adăugarea. Verifică produsele din coș înainte să încerci din nou.'
      : failure.message;

     error.hidden = false;
     error.focus();
     refreshCart(root.dataset.cartUrl);

    } finally {
     busy = false;
     updateButtons();
    }
   }, options);

   function tick() {
    var isClosed = closed();

    if (isClosed !== previousClosed) {
     previousClosed = isClosed;
     updateButtons();

     if (isClosed) {
      root.querySelector('[data-ce-product-deadline]').textContent =
       'Precomenzile de ' +
       (root.dataset.occasion === 'newyear' ? 'Revelion' : 'Crăciun') +
       ' sunt închise.';
     }
    }
   }

   var deepLink = new URLSearchParams(location.search).get('variant');

   if (deepLink && Array.from(select.options).some(function (o) {
    return o.value === deepLink;
   })) {
    select.value = deepLink;
   }

   sync(false, true);
   tick();

   var timer = setInterval(tick, 1000);

   root.ceProductCleanup = function () {
    clearInterval(timer);
    controller.abort();
    if (noticeOwner === root) dismissNotice();
    delete root.ceProductCleanup;
   };
  });
 }

 document.addEventListener('shopify:section:load', function (e) {
  init(e.target);
 });

 document.addEventListener('shopify:section:unload', function (e) {
  e.target.querySelectorAll('[data-ce-product]').forEach(function (root) {
   if (root.ceProductCleanup) root.ceProductCleanup();
  });
 });

 init(document);
})();